/**
 * 格式化工具模块
 * 提供数字格式化等通用格式化功能
 * 
 * @module common/utils/format
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 数字格式化（千分位，最多保留两位小数）
   * @param {number} number - 要格式化的数字
   * @returns {string} 格式化后的字符串
   * 
   * @example
   * watashi.common.thousandsSeparatorFormat(1234567.89); // "1,234,567.89"
   * watashi.common.thousandsSeparatorFormat(1000); // "1,000"
   */
  common.thousandsSeparatorFormat = function (number) {
    number = number != null ? number : 0;
    number = Number(number);
    if (isNaN(number)) {
      return '';  // 无效数字时返回默认值
    }
    return number.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  };

})(typeof window !== "undefined" ? window : this);
